import React, { useEffect, useState } from "react";

const DEFAULT_PAYLOAD = {
  subOrderId: "1253390336916460201",
  spotId: "1",
  source: "ONLINE_WEB"
};

const KrogerCheckinTest = () => {
  const [payload, setPayload] = useState(DEFAULT_PAYLOAD);
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState(null);
  const [messageId, setMessageId] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      if (event.origin !== window.location.origin) return;
      const data = event.data;
      if (data?.type !== "kroger-checkin-result") return;
      if (messageId && data.id !== messageId) return;
      setStatus("received");
      setResponse(data.response);
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [messageId]);

  const sendCheckin = (e) => {
    e.preventDefault();
    if (typeof window === "undefined" || typeof window.postMessage !== "function") {
      setStatus("error");
      setResponse({ error: "window.postMessage not available" });
      return;
    }

    const id =
      (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`;

    setStatus("pending");
    setResponse(null);
    setMessageId(id);

    window.postMessage(
      {
        type: "kroger-checkin",
        id,
        payload
      },
      window.location.origin
    );
  };

  const updateField = (field, value) => {
    setPayload((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="flex flex-col w-full p-6 gap-4">
      <div className="bg-white shadow rounded p-4">
        <h1 className="text-xl font-semibold mb-2">Kroger Check-in Test</h1>
        <p className="text-sm text-gray-600 mb-3">
          Install and enable the <strong>Kroger Pickup Check-in Relay</strong> browser extension,
          sign in to Ralphs/Kroger in this Chrome profile, then send a test call directly
          from Admin using the live session cookies.
        </p>
        <form className="grid grid-cols-1 md:grid-cols-3 gap-3" onSubmit={sendCheckin}>
          <label className="flex flex-col text-sm text-gray-700">
            Sub Order ID
            <input
              className="border rounded px-2 py-1 mt-1"
              value={payload.subOrderId}
              onChange={(e) => updateField("subOrderId", e.target.value)}
              required
            />
          </label>
          <label className="flex flex-col text-sm text-gray-700">
            Spot ID
            <input
              className="border rounded px-2 py-1 mt-1"
              value={payload.spotId}
              onChange={(e) => updateField("spotId", e.target.value)}
              required
            />
          </label>
          <label className="flex flex-col text-sm text-gray-700">
            Source
            <input
              className="border rounded px-2 py-1 mt-1"
              value={payload.source}
              onChange={(e) => updateField("source", e.target.value)}
              required
            />
          </label>
          <div className="md:col-span-3 flex items-center gap-3">
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition disabled:opacity-60"
              disabled={status === "pending"}
            >
              {status === "pending" ? "Sending..." : "Send Check-in"}
            </button>
            <span className="text-sm text-gray-700">
              Status: {status}
            </span>
          </div>
        </form>
      </div>

      <div className="bg-white shadow rounded p-4">
        <h2 className="text-lg font-semibold mb-2">Extension Response</h2>
        <pre className="text-xs bg-gray-100 p-3 rounded overflow-x-auto max-h-80">
{response ? JSON.stringify(response, null, 2) : "No response yet."}
        </pre>
      </div>
    </div>
  );
};

export default KrogerCheckinTest;




